"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ShapeBaseGLFilter = _interopRequireDefault(require("./ShapeBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ShapeTensorMagnitudeGLFilter extends _ShapeBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision highp float;

        uniform sampler2D t_tex;
        uniform vec2 screenSize;

        void main()
        {
            vec2 uv = gl_FragCoord.xy * screenSize;
            vec4 s = texture2D(t_tex, uv);
            s.z = 2.0*s.z - 1.0;
            s.z = (s.z < 0.0) ? -(s.z*s.z) : (s.z*s.z);
            s.xy = s.xy*s.xy;

            float x_y = s.x - s.y;
            float lambda1 = 0.5 * (s.x + s.y + sqrt (x_y * x_y + 4.0 * s.z*s.z));
            vec2 val = vec2(s.x - lambda1, s.z);

            vec3 result;
            if(dot(val,val)>0.0)
            {
                val = normalize(val);
                result = vec3(val.x,val.y,sqrt(lambda1));
            }
            else
            {
                result = vec3(0.0, 1.0, 0.0);
            }

            gl_FragColor.xy = 0.5*(result.xy+vec2(1.0)); // pack into positive numbers for XY components
            gl_FragColor.z = result.z;
            gl_FragColor.w = 1.0;
        }
        `;
    super(fsSource);
  }

}

exports.default = ShapeTensorMagnitudeGLFilter;